"use client";

import React, { useState, useContext, useEffect } from "react";
import {
  ViewModeContext,
  initialState,
  ViewModesState,
  inspectorStorageKey,
} from "./ViewModeContext";
import { useObject } from "@hooks/useObject";

export default function ViewModeProvider({ children }: { children: React.ReactNode }) {
  const [inspectorMode, setInspectorMode] = useState<ViewModesState["inspectorMode"]>(
    initialState.inspectorMode
  );

  useEffect(() => {
    localStorage.setItem(inspectorStorageKey, inspectorMode);
  }, [inspectorMode]);

  const context = useObject({
    inspectorMode,
    setInspectorMode,
  });

  return <ViewModeContext.Provider value={context}>{children}</ViewModeContext.Provider>;
}

export const useViewModeContext = () => useContext(ViewModeContext);
